import * as yup from "yup";

const emailRules = /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@(?!(?:[-]))[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
const sqlInjectionPattern = /(\b(SELECT|INSERT|UPDATE|DELETE|DROP|ALTER|CREATE|EXEC|UNION|--)\b|['";\\])/i;

const safeString = (label) =>
  yup
    .string()
    .required(`${label} is required`)
    .test(
      "no-sql-injection",
      `${label} contains potentially malicious characters or SQL keywords.`,
      function (value) {
        if (!value) return true;
        return !sqlInjectionPattern.test(value);
      }
    );

export const addUserSchema = yup.object().shape({
  firstName: safeString("First Name"),
  lastName: safeString("Last Name").notRequired(),
  email: yup
    .string()
    .required("Email is required")
    .matches(emailRules, { message: "Invalid email format" }),
  password: yup
    .string()
    .required("Password is required"),
  reEnterdPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords must match")
    .required("Confirm password is required"),
  roles: yup
    .array()
    .of(yup.number())
    .min(1, "Select at least one role")
    .required("Role is required"),
  roleNames: yup.object().nullable(),
  manager: yup.object().nullable(),
  location: yup.object().nullable(),
  purviewType: yup.object().nullable(),
  discount: yup.string().nullable(),
});